import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger'
import { loadState, saveState } from './localstorage';
import throttle from 'lodash/throttle';

import reducers from '../reducers';

// Setup the Redux store
const middlewares = [thunk];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(createLogger());
}


const persistedState = loadState();
//console.log('persisted state: ', persistedState);

const store = createStore(
  reducers,
  persistedState,
  compose(
    applyMiddleware(...middlewares)
  )
);

// limit calls to stringify redux state
store.subscribe(throttle(() => {
  const { form, ...rest } = store.getState();

  // Currently do NOT want to persist form state.
  const persistState = { ...rest };
  saveState(persistState);

  // NOTE: if you only want to persist certain state, do so like:
  // saveState({
  //   token: store.getState().token,
  //   user: store.getState().user
  // });
}, 1000));

export default store;


// WEBPACK FOOTER //
// ./src/config/store.js